export default {
  state: {
    articleTitle: '',
    articleContents: ''
  },
  mutations: {
    changeArticleContents (state, str) {
      state.articleContents = str
    },
    changeArticleTitle (state, str) {
      state.articleTitle = str
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/article.js